import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const CableSizeCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-cable-size-calculator" />;

export default CableSizeCalculatorGuidePage;
